module.exports = __webpack_public_path__ + "static/media/free_movie_tool_zh.4d16a311.png";